import ApplicationAdapter from './application';

export default class TrackingConsentPreference extends ApplicationAdapter {
  urlForQueryRecord(_query, _modelName) {
    return `${this.buildURL()}/tracking-consent-preference`;
  }

  update(attributes) {
    const url = `${this.buildURL()}/tracking-consent-preference`;
    return this.ajax(url, 'PATCH', {
      data: {
        data: { id: '0', type: 'tracking-consent-preferences', attributes },
      },
    });
  }
}
